import React, { useContext } from "react"
import { GlobalStateContext } from "../providers/GlobalStateProvider.jsx"
import { Banner, Checkbox } from "@shopify/polaris"
import { useTranslation } from "react-i18next"
import {
	canModifyKopyPagesThemeColors,
	isAutostoreDefaultThemeSelection,
	isAutostoreSpecificTheme,
} from "../../utils/kopyPagesThemes.js"

export const ThemeInstallationInfoBanner = ({
	themeIdSelected,
	publishThemeSelected,
	setPublishThemeSelected,
	colorPalette,
	modifyThemeColors,
}) => {
	const { state } = useContext(GlobalStateContext)
	const { t } = useTranslation()
	const theme = state.storeThemes.find(
		(theme) => theme.id === themeIdSelected,
	)

	// No compatible theme selected - will install new theme
	if (!themeIdSelected || !theme) {
		return (
			<Banner
				status="info"
				title={t("kopy_pages.a_new_theme_will_be_installed")}
			>
				<p style={{ marginBottom: "0.5rem" }}>
					{t("kopy_pages.ai_product_pages_only_work_with")}
				</p>

				<Checkbox
					label={
						<p style={{ fontSize: "0.85rem" }}>
							{t(
								"kopy_pages.set_theme_as_published_after_installation",
							)}
						</p>
					}
					checked={publishThemeSelected}
					onChange={() =>
						setPublishThemeSelected(!publishThemeSelected)
					}
				/>
			</Banner>
		)
	}

	const themeCurrentPalette = theme?.themePalette || null
	const isPaletteChanged = isAutostoreSpecificTheme(theme)
		? !isAutostoreDefaultThemeSelection(colorPalette)
		: themeCurrentPalette && themeCurrentPalette !== colorPalette
	const canModifySelectedThemeColors = canModifyKopyPagesThemeColors(theme)
	const willInstallNewTheme =
		isPaletteChanged &&
		(!modifyThemeColors || !canModifySelectedThemeColors)
	const willModifyThemeColors =
		isPaletteChanged && modifyThemeColors && canModifySelectedThemeColors

	if (willInstallNewTheme) {
		return (
			<Banner
				status="info"
				title={t("kopy_pages.a_new_theme_will_be_installed")}
			>
				<p style={{ marginBottom: "0.5rem" }}>
					{t("kopy_pages.ai_product_pages_only_work_with")}
				</p>

				<Checkbox
					label={
						<p style={{ fontSize: "0.85rem" }}>
							{t(
								"kopy_pages.set_theme_as_published_after_installation",
							)}
						</p>
					}
					checked={publishThemeSelected}
					onChange={() =>
						setPublishThemeSelected(!publishThemeSelected)
					}
				/>
			</Banner>
		)
	} else if (willModifyThemeColors) {
		return (
			<Banner status="info">
				<p>
					{t(
						"kopy_pages.the_page_will_be_installed_in_the_theme_selected",
					)}{" "}
					<b>
						{theme?.name}
						{theme?.title ? (
							<span>
								{" - "}
								{theme?.title}
							</span>
						) : (
							""
						)}
					</b>{" "}
					{t("kopy_pages.and_color_scheme_will_be_changed")}
				</p>
			</Banner>
		)
	} else {
		return (
			<Banner status="info">
				<p>
					{t(
						"kopy_pages.the_page_will_be_installed_in_the_theme_selected",
					)}{" "}
					<b>
						{theme?.name}
						{theme?.title ? (
							<span>
								{" - "}
								{theme?.title}
							</span>
						) : (
							""
						)}
					</b>
				</p>
			</Banner>
		)
	}
}
